<template>
  <v-layout row wrap>
    <vue-title :title="$t('competition.title')" />
    <v-flex xs12 md5>
      <v-layout column>
        <v-flex ma-1>
          <v-card>
            <v-card-actions class='d-flex justify-space-between'>
              <v-select :items="this.races" v-on:change="this.raceChanged" v-model="race" solo item-value="id" class="pt-4" item-text="name" hide-details />
              <v-switch v-model="red" class="mt-5 ml-4" />
            </v-card-actions>
            <v-card-actions class='d-flex justify-space-between'>
              <v-btn @click="previous()" color="info">
                {{ $t("ctrl.back") }}
              </v-btn>
              <v-btn color="default" @click="$refs.startDialog.show(startId + 1)">
                {{ this.startId + 1 }}/{{ this.starts }}
              </v-btn>
              <v-btn @click="next()" color="info">
                {{ $t("ctrl.next") }}
              </v-btn>
            </v-card-actions>
            <TextDialog ref="startDialog" title="Start" :onChanged="onStartDialog" />
            <ConfirmDialog 
              ref="dlgUnsavedChanges"
              :onConfirm="confirmUnsavedChanges"
              message="referee.unsavedChangesMessage"
              confirm="ctrl.ok"
              cancel="ctrl.cancel" />
          </v-card>
        </v-flex>
        <v-flex ma-1>
          <FCCRefereeRun ref="fccRun" :runs="runs" :red="red" :startId="startId" />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md7>
      <v-layout column>
        <v-flex ma-1>
          <FCCRefereePenalities :runs="runs" :red="red" :startId="startId" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    VTextField,
    VDataTable,
    VTooltip,
  } from 'vuetify/lib'
  import FCCRefereeRun from '../components/referee/FCCRefereeRun'
  import FCCRefereePenalities from '../components/referee/FCCRefereePenalities'
  import fccapi from '../fccapi.js'
  import TextDialog from '../dialogs/TextDialog'
  import ConfirmDialog from '../dialogs/ConfirmDialog'

  export default {
    name: 'Referee',
    data: () => ({
      search: "",
      headers: [
        { text: 'competition', value: 'competition' },
        { text: 'title', value: 'title' },
        { text: 'type', value: 'type' },
        { text: 'category', value: 'category' }
      ],
      races: [],
      runs: [],
      startId: 0,
      starts: 0,
      red: false,
      race: null,
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      }
    },
    props: {
      source: String
    },
    methods: {
      raceChanged: function() {
        fccapi.get(`races/${this.race}/runs`).then(d => {
          this.runs = d.data;
          this.runs.sort((a, b) => {
            return a.startNumber > b.startNumber ? 1 : -1;
          });
          this.loading = false;
          this.startId = 0;
          this.starts = Math.floor((this.runs.length+1) / 2);
        });
      },
      next: function() {
        if(this.$refs.fccRun.isDirty){
          this.$refs.dlgUnsavedChanges.show((this.startId + 1) % this.starts);
        }
        else this.confirmUnsavedChanges((this.startId + 1) % this.starts);
      },
      previous: function() {
        if(this.$refs.fccRun.isDirty){
          this.$refs.dlgUnsavedChanges.show((this.startId + this.starts - 1) % this.starts);
        }
        else this.confirmUnsavedChanges((this.startId + this.starts - 1) % this.starts);
      },
      onStartDialog: function(start){
        if(this.$refs.fccRun.isDirty){
          this.$refs.dlgUnsavedChanges.show((parseInt(start) + this.starts - 1) % this.starts);
        }
        else this.confirmUnsavedChanges((parseInt(start) + this.starts - 1) % this.starts);
      },
      confirmUnsavedChanges: function(n) {
        this.startId = n;
      },
      pad: function (str, max) {
        str = str.toString();
        return str.length < max ? this.pad("0" + str, max) : str;
      },
      onRunUpdated: function({run}){
        for(var i = 0; i < this.runs.length; i++){
          if(this.runs[i].id == run.id){
            this.runs[i].time = run.time
            this.runs[i].totalTime = run.totalTime;
            this.runs[i].additionalTime = run.additionalTime;
            this.runs[i].disqualification = run.disqualification;
            this.runs[i].remarks = run.remarks;
            this.runs[i].runPenalities = run.runPenalities;
            break;
          }
        }
      }
    },
    components: {
      VDataTable,
      VTextField,
      VTooltip,
      FCCRefereePenalities,
      FCCRefereeRun,
      TextDialog,
      ConfirmDialog
    },
    mounted() {
      fccapi.competitionGet('races').then((r) => {
          this.races = r.data;
      })
    },
    created() {
      this.$resultsHub.$on('run-updated', this.onRunUpdated)
    }
  }
</script>